<template>
	<div class="skyDatePickerRange" :style="{ width: width }">
		<el-date-picker
			v-model="timeValue"
			:type="pickerType"
			@change="startChange"
			v-bind="$attrs"
			:value-format="valueFormat"
			:unlink-panels="unlinkPanels"
			placeholder="开始时间"
			:start-placeholder="startPlaceholder"
			:end-placeholder="endPlaceholder"
			:picker-options="pickerOptions"
			:format="valueFormat"
			:clearable="clearable"
		>
		</el-date-picker>
		<span class="separate"> - </span>
		<el-date-picker
			v-model="endValue"
			:type="pickerType"
			@change="endChange"
			v-bind="$attrs"
			:value-format="valueFormat"
			:unlink-panels="unlinkPanels"
			placeholder="结束时间"
			:start-placeholder="startPlaceholder"
			:end-placeholder="endPlaceholder"
			:picker-options="pickerOptions"
			:format="valueFormat"
			:clearable="clearable"
		>
		</el-date-picker>
	</div>
</template>
<script>
export default {
	name: 'skyDatePickerRange',
	props: {
		value: {
			type: [String, Number, Array, Object],
		},
		placeholder: {
			type: String,
			default: '',
		},
		startPlaceholder: {
			type: String,
			default: '开始日期',
		},
		endPlaceholder: {
			type: String,
			default: '结束日期',
		},
		pickerOptions: {
			type: Object,
		},
		valueFormat: {
			type: String,
			default: 'yyyy-MM-dd',
		},
		pickerType: {
			type: String,
			default: 'date',
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		width: {
			type: String,
			default: '100%',
		},
		unlinkPanels: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			timeValue: '',
			endValue: '',
		};
	},
	methods: {
		change(val) {
			let res = [this.timeValue || '',this.endValue || ''];
			// if(this.timeValue) {
			// 	res.push(this.timeValue)
			// }
			// if(this.endValue) {
			// 	res.push(this.endValue)
			// }
			this.$emit('input', res);
			this.$emit('change', res);
		},
		startChange(val) {
			this.timeValue = val;
			this.change();
		},
		endChange(val) {
			this.endValue = val;
			this.change();
		}
	},
	watch: {
		value: {
			handler: function (val) {
				if (val && val.length) {
					this.timeValue = val[0];
					this.endValue = val[1];
				} else {
					this.timeValue = '';
					this.endValue = '';
				}
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>
<style lang="scss">
.skyDatePickerRange {
	display: flex;
	.separate {
		padding: 0 8px;
	}
}
</style>